import { get } from "lodash";

import { JsonSchema } from "./types";

export const getSchema = (
    schema: JsonSchema,
    currentPath: string[],
): JsonSchema => {
    let result = schema;

    currentPath
        .filter(_ => isNaN(parseInt(_, 10)))
        .forEach(_ => {
            if (result.type === "array") {
                const required = get(result, ["items", "required"], []);
                result = get(result, ["items", "properties", _], schema);
                if (result.type === "object" && required.length > 0) {
                    const keys = Object.keys(result.properties);
                    if (required.every(item => keys.includes(item))) {
                        result.required = required;
                    }
                }
            } else if (result.type === "object" || result.type === undefined) {
                result = get(result, ["properties", _], schema);
            }
        });
    return result;
};
